import { emit, events } from '@estee/elc-service-bus';

export class ToutLinkClickedUseCase {
    private siteUrl: string;

    constructor(siteUrl: string) {
        this.siteUrl = siteUrl;
    }

    public execute = async () => {
        emit(events.CHANGE_LOCATION, {
            // @TODO update this to use the plugin's output rather than hardcoding the protocol check
            redirectUrl:
                this.siteUrl.startsWith('http') || this.siteUrl.startsWith('/')
                    ? this.siteUrl
                    : `/${this.siteUrl}`
        });
    };
}
